__turbopack_context__.v({
  "quiz": "lQSpLa_quiz",
});
